import React, { Component } from "react";
import STable from "../../components/Common/STable";
import authService from "../../services/authService";
import NumberFormat from "react-number-format";

class ListMappingTable extends Component {
  columns = [
    // {
    //   path: "selected",
    //   label: " ",
    //   content: (item, index) => (
    //     <Checkbox
    //       onChange={() => this.props.handleCheckPrint(item, index)}
    //       isChecked={item.selected}
    //       id={`${index}Selected`}
    //     />
    //   )
    // },
    {
      path: "idx",
      label: "#",
      content: (activity, index, currentPage, limit) => (
        <span>{index + 1 + limit * (currentPage - 1)}</span>
      ),
    },
    {
      path: "name",
      label: "Group",
    },
    {
      path: "cust_items",
      label: "Customer Drawing",
      content: (item, index) => (
        <NumberFormat
          onClick={()=>this.props.handleOpenDetailCustomer(item)}
          style={{textDecoration: 'underline', cursor: item.cust_items>0?'pointer':''}}
          value={item.cust_items}
          displayType={"text"}
          thousandSeparator={true}
        />
      ),
    },
    {
      path: "items",
      label: "Supplier Drawing",
      content: (item, index) => (
        <NumberFormat
          onClick={()=>this.props.handleOpenDetail(item)}
          style={{textDecoration: 'underline', cursor: item.items>0?'pointer':''}}
          value={item.items}
          displayType={"text"}
          thousandSeparator={true}
        />
      ),
    },
  ];

  hideAction = (column) => {
    let col = column.filter(function (obj) {
      return obj.label !== "action";
    });
    return col;
  };
  render() {
    const { data, from, sortColumn, onSort, ...rest } = this.props;
    return (
      <STable
        columns={this.columns}
        data={data}
        sortColumn={sortColumn}
        onSort={onSort}
        {...rest}
        keyId="id_item_group_map"
      />
    );
  }
}

export default ListMappingTable;



// WEBPACK FOOTER //
// ./src/views/item_group/listMappingTable.jsx